import { useState } from "react";
import { useParams } from "react-router-dom";
import { client } from "../utils/axios";

const bgImage = require("../images/splash.19dd94a414793b5c0423.jpg");

const styles = {
  container: {
    minHeight: "100vh",
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    padding: "36px 32px",
    width: "100%",
    maxWidth: 380,
    boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
    position: "relative",
  },
  backBtn: {
    position: "absolute",
    top: 16,
    left: 16,
    background: "none",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: "#555",
    fontSize: 18,
    padding: 4,
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    color: "#222",
    marginBottom: 6,
    marginTop: 0,
  },
  subtitle: {
    fontSize: 14,
    color: "#666",
    marginBottom: 24,
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    color: "#333",
    marginBottom: 8,
    display: "block",
  },
  input: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: 8,
    border: "1.5px solid #ddd",
    fontSize: 15,
    outline: "none",
    boxSizing: "border-box",
    marginBottom: 8,
  },
  hint: {
    fontSize: 13,
    color: "#888",
    marginBottom: 20,
    textAlign: "center",
  },
  btn: {
    width: "100%",
    padding: "14px",
    background: "#f5a623",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 700,
    cursor: "pointer",
    marginTop: 4,
  },
  otpRow: {
    display: "flex",
    gap: 10,
    justifyContent: "center",
    marginBottom: 20,
  },
  otpBox: {
    width: 44,
    height: 52,
    textAlign: "center",
    fontSize: 20,
    fontWeight: 700,
    borderRadius: 8,
    border: "1.5px solid #ddd",
    outline: "none",
  },
  resend: {
    textAlign: "center",
    marginBottom: 16,
    fontSize: 14,
    color: "#888",
  },
  resendLink: {
    color: "#2ecc71",
    fontWeight: 600,
    cursor: "pointer",
    background: "none",
    border: "none",
    fontSize: 14,
    padding: 0,
  },
};

const UserPrescription = () => {
  const { visitId } = useParams();

  const [step, setStep] = useState("mobile");
  const [mobile, setMobile] = useState("");
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

const sendOtp = () => {
  setLoading(true);
  setError("");

  if (!mobile || mobile.length < 10) {
    setError("Enter valid mobile number");
    setLoading(false);
    return;
  }

  client
    .post("/visit/send-otp", { mobile })
    .then((res) => {
      if (!res || res.status !== 200) {
        setError(res?.data?.message || "Failed to send OTP");
        return;
      }

      setStep("otp"); // ✅ only on success
    })
    .catch((err) => {
      setError(err?.response?.data?.message || "Error sending OTP");
    })
    .finally(() => {
      setLoading(false);
    });
};

  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;
    const updated = [...otpDigits];
    updated[index] = value;
    setOtpDigits(updated);
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

const verifyOtp = () => {
  setLoading(true);
  setError("");

  const otp = otpDigits.join("");

  if (otp.length !== 6) {
    setError("Please enter valid 6-digit OTP");
    setLoading(false);
    return;
  }

  client
    .post("/visit/verify-otp", { mobile, otp })
    .then((verifyRes) => {
      // 🔥 HANDLE YOUR AXIOS BEHAVIOR HERE
      if (!verifyRes || verifyRes.status !== 200) {
        setError(verifyRes?.data?.message || "Invalid OTP");
        throw new Error("STOP_FLOW"); // ❗ stop next .then
      }

      // ✅ only if OTP valid
      return client.post(
        "/visit/print-prescription-report",
        { visitId },
        { responseType: "text" }
      );
    })
    .then((res) => {
      if (!res) return; // safety

      if (!res.data) {
        setError("No prescription found");
        return;
      }

      setHtml(res.data);
      setStep("done");
    })
    .catch((err) => {
      if (err.message === "STOP_FLOW") return; // ignore manual stop

      setError(err?.response?.data?.message || "Invalid OTP");
    })
    .finally(() => {
      setLoading(false);
    });
};

  const goBack = () => {
    setOtpDigits(["", "", "", "", "", ""]);
    setStep("mobile");
  };

  if (loading) return (
    <div style={{ ...styles.container }}>
      <div style={{ color: "#fff", fontSize: 18, fontWeight: 600 }}>Loading...</div>
    </div>
  );

  if (step === "done") {
    if (!html) return <div>No prescription found</div>;
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>

        {/* Back arrow on OTP step */}
        {step === "otp" && (
          <button style={styles.backBtn} onClick={goBack}>
            &#8592;
          </button>
        )}

        {step === "mobile" && (
          <>
            {/* <h2 style={styles.title}>Login</h2>
            <p style={styles.subtitle}>Please login to continue</p> */}
            <label style={styles.label}>Enter Your Mobile Number</label>
            <input
              style={styles.input}
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter Your Phone Number"
              type="tel"
              maxLength={10}
            />
            <p style={styles.hint}>We will send an OTP to this number</p>
            <button style={styles.btn} onClick={sendOtp}>Login</button>

                    {error && (
  <div style={{
    color: "red",
    fontSize: 14,
    marginBottom: 10,
    textAlign: "center"
  }}>
    {error}
  </div>
)}
          </>
        )}


        {step === "otp" && (
          <>
            <h2 style={{ ...styles.title, marginTop: 28 }}>OTP</h2>
            <p style={styles.subtitle}>
              Please enter the 6-digit OTP code sent to your mobile number {mobile}
            </p>
            <div style={styles.otpRow}>
              {otpDigits.map((digit, i) => (
                <input
                  key={i}
                  id={`otp-${i}`}
                  style={styles.otpBox}
                  value={digit}
                  maxLength={1}
                  onChange={(e) => handleOtpChange(e.target.value, i)}
                  onKeyDown={(e) => handleOtpKeyDown(e, i)}
                  type="tel"
                />
              ))}
            </div>
            <div style={styles.resend}>
              <button style={styles.resendLink} onClick={sendOtp}>Resend</button>
              {" "}OTP
            </div>
            <button style={styles.btn} onClick={verifyOtp} disabled={loading}>Verify OTP</button>

            {error && (
  <div style={{
    color: "red",
    fontSize: 14,
    marginBottom: 10,
    textAlign: "center"
  }}>
    {error}
  </div>
)}
          </>
        )}

      </div>
    </div>
  );
};

export default UserPrescription;